import React, { useEffect, useState } from 'react';

const LoadingSpinnerWithImage = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [loadingProgress, setLoadingProgress] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setLoadingProgress((prevProgress) => {
                const newProgress = prevProgress + 5; // Faster increment
                if (newProgress >= 100) {
                    clearInterval(timer);
                    setTimeout(() => setIsVisible(true), 500); // Shorter delay
                    return 100;
                }
                return newProgress;
            });
        }, 15); // Faster interval

        return () => clearInterval(timer);
    }, []);

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ position: 'relative', width: '256px', height: '256px', overflow: 'hidden' }}>
                    <img
                        src="images/chair.avif"
                        alt="Chair"
                        width={256}
                        style={{
                            objectFit: 'contain',
                            maskImage: `linear-gradient(to top, black ${loadingProgress}%, transparent ${loadingProgress}%)`,
                            WebkitMaskImage: `linear-gradient(to top, black ${loadingProgress}%, transparent ${loadingProgress}%)`,
                            filter: 'grayscale(100%)',
                            transition: 'opacity 0.25s',
                            opacity: isVisible ? 1 : 0.5,
                        }}
                    />
                </div>
                <br />
                <p style={{ fontSize: '1rem', fontWeight: '600', transition: 'opacity 0.25s', opacity: isVisible ? 1 : 0.5 }}>
                    CARGANDO ...
                </p>
            </div>
        </div>
    );
};

export default LoadingSpinnerWithImage;